import type React from 'react';
import { useMemo, useState } from 'react';
import type { ListViewType, ViewModeByDevice } from '@/app/common/viewModeUtils.ts';
import { isListView } from '@/app/common/viewModeUtils.ts';
import { getLayoutType, type LAYOUT_TYPE } from '@/app/components/search/components/LayoutManager/utils.ts';

export type ViewModeState = {
  viewMode: ViewModeByDevice;
  setViewMode: React.Dispatch<React.SetStateAction<ViewModeByDevice>>;
  listView: ListViewType;
  layoutType: LAYOUT_TYPE;
};

// Seeded from pageWrapperData, which is resolved for this search and lands before this page mounts, so the
// results page never opens on the view mode of the page navigated away from. (MPH-931)
export const useViewMode = (viewModeServer: ViewModeByDevice, isDesktop: boolean): ViewModeState => {
  const [viewMode, setViewMode] = useState<ViewModeByDevice>(viewModeServer);

  const currentViewMode = isDesktop ? viewMode.desktop : viewMode.mobile;
  const listView = useMemo(() => isListView(currentViewMode), [currentViewMode]);
  const layoutType = useMemo(() => getLayoutType(currentViewMode, isDesktop), [currentViewMode, isDesktop]);

  return { viewMode, setViewMode, listView, layoutType };
};
